import { TFunction } from 'i18next';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type DropFirst<T extends unknown[]> = T extends [any, ...infer U] ? U : never;
type TFunctionParams = Parameters<TFunction>;
type CustomTFunction<T> = (key: T | T[], ...rest: DropFirst<TFunctionParams>) => ReturnType<TFunction>;

/**
 * Wrapper arround i18next useTranslation hook.
 */
export const useI18nTranslation = <T,>() => {
	const { t: _t, i18n } = useTranslation();
	const t = _t as CustomTFunction<T>;

	return {
		t,
		transWithJSX(key: T, JSXMap: Record<string, ReactNode>) {
			const msgArray = t(key).split(/({{.*?}})/);
			return (
				<>
					{msgArray.map((subMsg) => {
						const [match, key] = subMsg.match(/{{(.*?)}}/) || [];
						return key ? JSXMap[key] || match : subMsg;
					})}
				</>
			);
		},
		i18n,
	};
};
